import React from 'react';
import { StatisticCard } from '../StatisticCard/StatisticCard';
import { DriverStop, DriverStopPeriod, formattingDurationResult } from 'entities/navigation';
import dayjs from 'dayjs';
import { useIntl } from 'react-intl';

interface TruckStopProps {
  driverStopPeriod: DriverStopPeriod;
  driverStopItem?: DriverStop;
}

export const TruckStop = (props: TruckStopProps) => {
  const { driverStopPeriod, driverStopItem } = props;
  const isMore8h = driverStopPeriod === DriverStopPeriod.more8hours;
  const { formatMessage } = useIntl();
  const secondText = isMore8h
    ? `${formatMessage({ id: 'driverRest' })} (> 8 ${formatMessage({ id: 'hours' })})`
    : `${formatMessage({ id: 'truckStop' })} (> 15 ${formatMessage({ id: 'min' })})`;

  const iconKind = isMore8h ? 'timerHalf' : 'timerQuarter';
  if (!driverStopItem) {
    return <StatisticCard iconKind={iconKind} primaryText={`0`} secondaryText={secondText} />;
  }

  return (
    <StatisticCard
      iconKind={iconKind}
      primaryText={`${driverStopItem.count} - ${formattingDurationResult(
        dayjs.duration(driverStopItem.time, 'minutes')
      )}`}
      secondaryText={secondText}
    />
  );
};
